let ssrCache = {};
export const setSSRCache = (newCache) => {
    ssrCache = newCache;
};
export const getSSRCache = () => {
    return ssrCache;
};
